class ZOProductCombo extends HTMLElement {
  connectedCallback() {
    this.checkboxes = Array.from(this.querySelectorAll('[data-zo-combo-item]'));
    this.total = this.querySelector('[data-zo-combo-total]');
    this.button = this.querySelector('[data-zo-combo-submit]');
    this.status = this.querySelector('[data-zo-combo-status]');

    this.checkboxes.forEach((checkbox) => checkbox.addEventListener('change', () => this.update()));
    this.button?.addEventListener('click', () => this.addSelected());
    this.update();
  }

  update() {
    const selected = this.checkboxes.filter((checkbox) => checkbox.checked);
    const totalCents = selected.reduce((sum, checkbox) => sum + Number(checkbox.dataset.price || 0), 0);
    const unavailableSelected = selected.some((checkbox) => checkbox.dataset.available !== 'true');

    if (this.total) {
      const currency = this.dataset.currency || 'HKD';
      const locale = document.documentElement.lang || 'en-HK';
      this.total.textContent = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(totalCents / 100);
    }

    if (this.button) {
      this.button.disabled = selected.length === 0 || unavailableSelected;
      this.button.textContent = unavailableSelected ? 'SELECTED ITEM OUT OF STOCK' : 'ADD SELECTED TO CART';
    }

    if (this.status) this.status.textContent = '';
  }

  async addSelected() {
    if (!this.button || this.button.disabled) return;

    const items = this.checkboxes
      .filter((checkbox) => checkbox.checked && checkbox.dataset.available === 'true')
      .map((checkbox) => ({ id: Number(checkbox.value), quantity: 1 }));

    if (!items.length) return;

    this.button.disabled = true;
    this.button.textContent = 'ADDING…';

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) throw new Error('Unable to add the selected set.');
      window.location.assign(this.dataset.cartUrl || '/cart');
    } catch (error) {
      this.button.disabled = false;
      this.button.textContent = 'ADD SELECTED TO CART';
      if (this.status) this.status.textContent = error.message;
    }
  }
}

if (!customElements.get('zo-product-combo')) {
  customElements.define('zo-product-combo', ZOProductCombo);
}
